import { orderXClient } from '@/service/client'
import { ChangePasswordRequest, ChangePasswordResponse } from '@/types/generated/common/auth'
import {
  ConfirmPasswordResetRequest,
  ConfirmPasswordResetResponse,
  RequestPasswordResetRequest,
  RequestPasswordResetResponse,
  ServerMessage,
} from '@/types/generated/public_api'
import type { ErrorResponse } from '@/types/service'

export async function requestPasswordReset(payload: RequestPasswordResetRequest) {
  try {
    const { data } = await orderXClient.post<ServerMessage>('/api', {
      requestPasswordReset: payload,
    })
    const requestPasswordResetResponse =
      data.requestPasswordResetResponse as RequestPasswordResetResponse
    if (!requestPasswordResetResponse.success) {
      return Promise.reject({
        status: 400,
        message: requestPasswordResetResponse.message,
      })
    }
    return requestPasswordResetResponse
  } catch (e) {
    const error = e as ErrorResponse
    return Promise.reject(error)
  }
}

export async function confirmPasswordReset(payload: ConfirmPasswordResetRequest) {
  try {
    const { data } = await orderXClient.post<ServerMessage>('/api', {
      confirmPasswordReset: payload,
    })
    const confirmPasswordResetResponse =
      data.confirmPasswordResetResponse as ConfirmPasswordResetResponse
    if (!confirmPasswordResetResponse.success) {
      return Promise.reject({
        status: 400,
        message: confirmPasswordResetResponse.message,
      })
    }
    return confirmPasswordResetResponse
  } catch (e) {
    const error = e as ErrorResponse
    return Promise.reject(error)
  }
}

export async function changePassword(payload: ChangePasswordRequest) {
  try {
    const { data } = await orderXClient.post<ServerMessage>('/api', { changePassword: payload })
    const changePasswordResponse = data.changePasswordResponse as ChangePasswordResponse
    if (!changePasswordResponse?.success) {
      return Promise.reject({
        status: 400,
        message: changePasswordResponse?.errorMessage || 'Failed to change password',
      })
    }
    return changePasswordResponse
  } catch (e) {
    const error = e as ErrorResponse
    return Promise.reject(error)
  }
}
